<template>
    <div id="father">
        <!-- ################    Top Menu Bar    ################# -->
        <div align="center" class="head0" id="part0">
            <div align="center" class="head0_2">

                <img src="/static/imgs/exp/lg_exp_advice.png" alt="Logo Advice" class="im_logol" onMouseOver="this.style.cursor='pointer'" @click="showdiv(0)">

            </div>
        </div>

        <br><br>

        <!-- ################    Barra flutuante redes sociais   ################# -->
        <div class="barra_flutua">
            <a target="_blank" href="https://www.facebook.com/adviceparaiba/"><img src="/static/imgs/exp/ic_face.png" alt="facebook" class="im_social_vert"></a><br/>
            <a target="_blank" href="https://www.instagram.com/adviceparaiba/"><img src="/static/imgs/exp/ic_insta.png" alt="instagram" class="im_social_vert"></a><br/>
            <a target="_blank" href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg/"><img src="/static/imgs/exp/ic_youtube.png" alt="youtube" class="im_social_vert"></a><br/>
            <a href="https://twitter.com/intent/tweet/?text=Advice%20Para%C3%ADba&amp;url=http%3A%2F%2Fadviceparaiba.com" target="_blank"><img src="/static/imgs/exp/ic_twitter.png" class="im_social_vert"></a><br/>
            <a href="mailto:?subject=Advice%20Para%C3%ADba&amp;body=http%3A%2F%2Fadviceparaiba.com" target="_blank"><img src="/static/imgs/exp/ic_email.png" class="im_social_vert"></a><br/>
        </div>


        <!-- ################    Home / Mosaico    ################# -->
        <div class="back01" >
            <div class="bodyp1">
                <div class="bodysubp2">
                    <div class="divF2" @click="showdiv(1)" onMouseOver="this.style.cursor='pointer'">
                        <span class="sp_tit_img">QUEM SOMOS</span>
                        <img src="/static/imgs/exp/bt_exp1quem.jpg" alt="Foto2 Estab" class="imF2"><br>
                    </div>
                    <div class="divF2" @click="showdiv(3)" onMouseOver="this.style.cursor='pointer'">
                        <span class="sp_tit_img">PARCEIROS</span>
                        <img src="/static/imgs/exp/bt_exp3parceiros.jpg" alt="Foto3 Estab" class="imF2"><br>
                    </div>
                </div>
                <div class="bodysubp2">
                    <div class="divF2" @click="showdiv(2)" onMouseOver="this.style.cursor='pointer'">
                        <span class="sp_tit_img">EQUIPE</span>
                        <img src="/static/imgs/exp/bt_exp2equipe.jpg" alt="Foto2 Estab" class="imF2"><br>
                    </div>
                    <div class="divF2" @click="showdiv(4)" onMouseOver="this.style.cursor='pointer'">
                        <span class="sp_tit_img">GALERIA</span>
                        <img src="/static/imgs/exp/bt_exp4galeria.jpg" alt="Foto3 Estab" class="imF2"><br>
                    </div>
                </div>
            </div>

            <div class="di_news">
                <img height="60px" src="/static/imgs/exp/entre_nossa_viagem.png"/>
                <input type="text" class="ipt_news"  v-on:keyup.enter="closeKey()" onsubmit="closeKey()" v-model="new_email" placeholder="Digite seu e-mail...">
                <div class="bt_criar" onMouseOver="this.style.cursor='pointer'" @click="sendNewsletter()">
                    <img width="100px" height="28" src="/static/imgs/exp/bg_enviar.png"/>
                    <span class="span_criar">ENVIAR</span>
                </div>
            </div>
        </div>



        <!-- ################    Sub - Partes    ################# -->
        <div id="part1" class="di_part1">
            <img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><span class="sp_title">QUEM SOMOS</span><img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/>
            <br/><br/><br/>
            <div style="width: 100%;">
                <div style="width: 30%; display: inline-block; position: relative; display: inline-block; vertical-align: top; margin-right: 20px;">
                    <span class="sp_interno">
                    &emsp;A Expedição Advice Paraíba faz parte
                    de um projeto que nasce em torno de
                    um ideal: Registrar, mapear, e divulgar
                    sempre a melhor direção, para que todos
                    possam desfrutar das verdadeiras
                    riquezas do estado da Paraíba.
                    </span>
                </div>
                <div style="width: 30%; display: inline-block; margin-left: 20px;">
                    <span class="sp_interno">
                    &emsp;Existe algo especial em nossa terra.
                    A nossa cultura, a nossa história, as
                    belezas naturais que nos rodeiam, e
                    toda a hospitalidade do nosso povo,
                    faz dessa expedição uma grande
                    oportunidade de todos estarem
                    profundamente conectados com
                    o nosso Estado.
                    </span>
                </div>
            </div>



        </div>

        <div id="part2" class="di_part2">
            <img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><span class="sp_title">EQUIPE</span><img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/>
            <br/><br/><br/><br/>
            <div style="width: 100%;">
                <div style="width: 20%; display: inline-block; margin-right: 20px;">
                    <span class="sp_interno2">
                    <b>Beto Rabello</b><br/>
                    Coordenador Geral<br/>
                    <br/>
                    <b>Marco Pimentel</b><br/>
                    Fotografia<br/>
                    <br/>
                    <b>Décio Moura Neto</b><br/>
                    Piloto Especialista Off Road<br/>
                    <br/>
                    <b>Derzu Omaia</b><br/>
                    Rede e Sistemas<br/>
                    </span>
                </div>
                <div style="width: 20%; display: inline-block; margin-left: 20px; vertical-align: top;">
                    <span class="sp_interno">
                    <br/>
                    <b>João Paulo Jurema</b><br/>
                    Coordenador de Mídia<br/>
                    <br/>
                    <b>Bruno Serpa</b><br/>
                    Produção Audiovisual<br/>
                    <br/>
                    <b>Sérgio Sombra</b><br/>
                    Design Gráfico<br/>
                    </span>
                </div>
            </div>
        </div>

        <div id="part3" class="di_part3">
            <img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><span class="sp_title">PARCEIROS</span><img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/>
            <br/><br/><br/><br/><br/>
            <div style="position: relative; width: 100%; ">
                <div class="di_patro_im">
                    <a target="_blank" href="http://www.graficasantamarta.com.br"><img src="/static/imgs/exp/parceiro01.png" alt="Gráfica Santa Marta" class="im_parceiro"/></a>
                </div>
                <div class="di_patro_im" style="margin-right: 40px; margin-left: 40px;">
                    <a target="_blank" href="http://www.manairashopping.com"><img src="/static/imgs/exp/parceiro02.png" alt="Manaíra Shopping" class="im_parceiro" style="width: 19vw;"/></a>
                </div>
                <div class="di_patro_im">
                    <a target="_blank" href="http://nissanpb.com.br/"><img src="/static/imgs/exp/parceiro03.png" alt="Nissan Carneiro" class="im_parceiro"/></a>
                </div>
            </div>
            <div style="width: 100%; margin-top: -10px">
                <div class="di_patro">
                    <span class="sp_interno">
                    &emsp;Um dos maiores e mais modernos parques
                    gráficos do Brasil, com a unidade da Paraíba
                    e duas em São Bernardo do Campo, São Paulo.
                    Presente nas principais regiões do país,
                    com atuação em todo o território nacional.
                    </span>
                </div>
                <div class="di_patro" style="margin-right: 40px; margin-left: 40px;">
                    <span class="sp_interno">
                    &emsp;Maior e mais completo centro comercial da Paraíba, com mais de 260 lojas, e diversas opções de lazer, como cinema, boliche e parques infatins.
                    O Manaíra Shopping se mantém há 29 anos como
                    referência no mercado.
                    </span>
                </div>
                <div class="di_patro">
                    <span class="sp_interno">
                    &emsp;Fundada em 2000 a Carneiro Automotores é a
                    concessionária Nissan do Brasil mais antiga em
                    operação no país. Com vasta experiência no mercado
                    de João Pessoa através da co-irmã J.Carneiro Renault.
                    </span>
                </div>
            </div>
        </div>

        <div id="part4" class="di_part4">
            <img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><span class="sp_title">GALERIA</span><img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><br/>

            <div style="display: inline-block;">
            <!-- ################    Album Galeria    ################# -->
            <div class="scrollhorizontal">
                <div v-for="item in albuns" class="di_categoria" @click="showGalery(item.id, true)" onMouseOver="this.style.cursor='pointer'">
                    <img :src="item.fotos[0].imgPath" alt="album" class="im_categoria2"/>
                    <span class="tx_categoria"> {{ item.legenda }} </span>
                </div>
            </div>
            </div>

        </div>

        <div id="part5" class="di_part5">
            <img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/><span class="sp_title">PRODUZIDO POR</span><img src="/static/imgs/exp/ic_pneu.png" alt="marca pneu" class="im_pneu"/>
            <br/><br/><br/><br/><br/>
            <img src="/static/imgs/exp/lg_advice.png" alt="logo advice" class="im_expadvice" onMouseOver="this.style.cursor='pointer'" @click="showdiv(0)"/>

            <br/>
            <br/>
            <a href="/static/pages/politicaprivacidade.html"><span style="font-size: 3vh; ">Privacy Policy</span></a>
        </div>

        <div class="overlay"></div>

        <div class="overgalery" @click="showGalery(0, false)">
            <div style="text-align: right;"><img  src="/static/imgs/exp/bt_close.png" alt="Button Close" class="im_close" onMouseOver="this.style.cursor='pointer'"/></div>
            <span class="tx_categoria3"> {{ albuns[albInd].legenda }} </span><br/>
            <div class="galery_container">
                <div v-for="item in albuns[albInd].fotos" class="div_galery" @click.stop.prevent="">
                    <img  v-if="item.imgPath!=null" :src="item.imgPath" alt="Foto Principal" class="imgGalery"/><br>
                    <span class="tx_categoria2"> &emsp;{{ item.legenda }} </span><br>
                    <br/>
                </div>
            </div>
        </div>

    </div>
</template>



<script>
    import axios from 'axios'
    import qs from 'qs';

    export default {
        name: 'Estabelecimento',
        data () {
            return {
                //baseUrlImg: 'http://localhost:8082/ADVICE_SERVER/',
                baseUrlImg: 'https://advice.domm.com.br:8445/ADVICE_SERVER/',
                //baseUrlApi: 'http://localhost:8082/AdviceServer/restapi/search/',
                baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',
                new_email: "",
                showShare: false,
                showingSearch: false,
                response: {
                    status: "ok"
                },
                telefoneUteis: [
                    {
                        nome: "Polícia",
                        tel: "190"
                    },
                    {
                        nome: "SAMU",
                        tel: "192"
                    },
                    {
                        nome: "Bombeiros",
                        tel: "193"
                    },
                    {
                        nome: "Rodoviária Federal",
                        tel: "191"
                    },
                    {
                        nome: "Rodoviária Estadual",
                        tel: "198"
                    }
                ],
                barra_pat: [
                    {
                        imgPath: "static/imgs/pat_grafica2.png",
                        url: "http://www.graficasantamarta.com.br"
                    },
                    {
                        imgPath: "static/imgs/pat_manaira2.png",
                        url: "http://www.manairashopping.com.br"
                    },
                    {
                        imgPath: "static/imgs/pat_jcarneiro2.png",
                        url: "http://www.jcarneiro.com.br"
                    },
                    {
                        imgPath: "static/imgs/pat_elizabeth2.png",
                        url: "http://www.ceramicaelizabeth.com.br"
                    },
                    {
                        imgPath: "static/imgs/pat_luck2.png",
                        url: "http://www.luckreceptivo.com.br"
                    }
                ],
                albuns: [
                    {
                        id: 0,
                        legenda: "BARRA DO MAMANGUAPE",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/24.jpg",
                                legenda: "A nossa Expedição nos levou para a Barra do Mamanguape, distrito da cidade de Rio Tinto, às margens do rio Mamanguape. No ponto em que as águas do rio e do mar se misturam, os conjuntos de corais podem ser vistos quando a maré está baixa. Lá, fica a sede do Projeto Peixe-Boi-Marinho."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/25.jpg",
                                legenda: "Um paraíso chamado Pontal da Barra do Mamanguape."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/26.jpg",
                                legenda: "Como não ficar com água na boca? Culinária impecável."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/27.jpg",
                                legenda: "Como não ficar com água na boca? Culinária impecável."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/28.jpg",
                                legenda: "Essa Paraíba é uma fábrica de delícias. Uma gastronomia ímpar, que faz bonito em qualquer lugar do mundo. Humm.."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/29.jpg",
                                legenda: "Aldeia Tramataia, às margens do rio Mamanguape. Naturalmente o nosso litoral norte se mostra um paraíso feito nos mínimos detalhes por Deus. Vem conhecer! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/30.jpg",
                                legenda: "Barra de Mamanguape é um refúgio para a paz e um convite ao descanso do dia a dia. O destino certo para se conectar à natureza e sua calmaria em todas as formas: manguezais, arrecifes, rio, mar e gastronomia indígena. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/31.jpg",
                                legenda: "Que tal os recifes milenares da foz do rio Mamanguape? Uma beleza de nos encher os olhos, e a alma!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/33.jpg",
                                legenda: "O Pontal da Barra do Mamanguape passando pela sua timeline para suavizar e embelezar o seu dia."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/34.jpg",
                                legenda: "Uma mistura perfeita de cores na foz do Rio Mamanguape. Uma obra prima!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/43.jpg",
                                legenda: "Barra do Mamanguape é uma praia muito tranquila, e de mar calmo, com várias formações de arrecifes. Um ótimo lugar para descanso, e ótimos passeios."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/50.jpg",
                                legenda: "E esse ensopado de aratu? Uma iguaria sem igual do Naturezas Bar e Restaurante em Barra do Mamanguape. Uma delícia!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DO MAMANGUAPE/55.jpg",
                                legenda: "Linda essa Igreja que fica na praia de Coqueirinho do Norte, desfeito que pertence ao município de Marcação. As praias da Paraíba e suas peculiaridades culturais e históricas."
                            },
                        ]
                    },
                    {
                        id: 1,
                        legenda: "AREIA VERMELHA",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/AREIA VERMELHA/116.jpg",
                                legenda: "A ilha Areia Vermelha é constituída por um banco de areia ficando preso atrás da barreira de corais, ela sempre aparece quando a maré está baixa e se situa a cerca de 800 metros do litoral "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/AREIA VERMELHA/117.jpg",
                                legenda: "Esse paraíso isolado com águas calmas faz parte do Parque Estadual Marinho de Areia Vermelha e pode ser visitado de barco, jet ski ou catamarã."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/AREIA VERMELHA/118.jpg",
                                legenda: "A ilha proporciona uma bela vista do Oceano Atlântico e da costa paraibana. Bares flutuantes atendem aos turistas no local e a #dicaadvice é experimentar o delicioso caranguejo no molho de coco."
                            },
                        ]
                    },
                    {
                        id: 2,
                        legenda: "BARRA DO CAMARATUBA",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/1.jpg.jpg",
                                legenda: "E que tal esse pôr do sol na foz do Rio Camaratuba? Demais!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/10.jpg",
                                legenda: "Expedição Advice Nissan Frontier. A Paraíba de um jeito que você nunca viu!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/11.jpg",
                                legenda: "Recifes da foz do Rio Guajú - Barra de Camaratuba - Mataraca/PB"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/12.jpg",
                                legenda: "Foz do Rio Camaratuba - Barra de Camaratuba - Mataraca/PB - Expedição Advice Nissan Frontier."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/13.jpg",
                                legenda: "Linda visão não é mesmo? Você desceria na tirolesa na foz do Rio Guajú? Para os que gostam de adrenalina esse é um ótimo lugar."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/14.jpg",
                                legenda: "Uma visão aérea de um dos cartões postais da Barra do Camaratuba! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/15.jpg",
                                legenda: "Existe um espírito de viajante em todos nós. Estamos em constante expedição pela vida. Você já conhece a Paraíba? Venha fazer parte dessa aventura conosco! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/2.jpg.jpg",
                                legenda: "A foz do Rio Guajú - Um lugar perfeito para você que gosta de aproveitar o melhor."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/3.jpg.jpg",
                                legenda: "A famosa Boca da Barra. O encontro do Rio Camaratuba com o mar. Um lugar perfeito para dar aquele mergulho! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/32.jpg",
                                legenda: "A foz do Rio Guajú é um lugar perfeito para passar o dia com pessoas que amamos."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/38.jpg",
                                legenda: "A Nissan acredita no turismo da Paraíba"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/39.jpg",
                                legenda: "A Nissan Frontier chega em todos os lugares."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/4.jpg.jpg",
                                legenda: "Que tal um passeio de canoa pelo Rio Guajú? Um show de natureza!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/40.jpg",
                                legenda: "Estamos bem acompanhados."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/42.jpg",
                                legenda: "Barra do Camaratuba é um distrito da cidade de Mataraca na Paraíba. Uma vila de pescadores charmosíssima, um lugar tranquilo e paradisíaco."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/5.jpg.jpg",
                                legenda: "A tirolesa na foz do Rio Guajú para os que gostam de adrenalina! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/53.jpg",
                                legenda: "Esse é o Memorial André Vidal de Negreiros e Pedro Poty. Localizado na Reserva Ecológica Manjericão no município de Mataraca - PB. Ponto de parada obrigatória para quem vem a Barra do Camararuba. Muita história, e belezas naturais."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/56.jpg",
                                legenda: "A beleza do Rio Camaratuba é inigualável."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/57.jpg",
                                legenda: "Muitos passeios. Muitos pontos a serem contemplados, fazem do Rio Camaratuba parada obrigatória, para quem não abre mão de um turismo nativo e natural. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/58.jpg",
                                legenda: "Céu. Canoas. Rio. Paz. Uma pintura natural para os olhos mais ávidos a criação"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/6.jpg.jpg",
                                legenda: "Expedição Advice Nissan Frontier - A Paraíba como você nunca viu! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/63.jpg",
                                legenda: "Barra do Camaratuba é um importante ponto de produção de energia eólica."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/64.jpg",
                                legenda: "O artesanato nativo paraibano tem algo a mais."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/65.jpg",
                                legenda: "O artesanato nativo super atraente. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/66.jpg",
                                legenda: "Existe algo no sorriso e na hospitalidade do povo paraibano. Quem vem, não quer ir embora."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/67.jpg",
                                legenda: "Adrenalina na tirolesa do Rio Guajú"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/7.jpg.jpg",
                                legenda: "Foz do Rio Guajú - Barra de Camaratuda - Mataraca/PB"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/8.jpg.jpg",
                                legenda: "Que lugar maravilhoso! A Reserva Ecológica Manjericão nos proporciona cenários paradisíacos para os olhos mais exigentes. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BARRA DE CAMARATUBA/9.jpg.jpg",
                                legenda: "Você consegue sentir a mística da Barra do Camaratuba?"
                            },
                        ]
                    },
                    {
                        id: 3,
                        legenda:"CABEDELO",
                        indFoto: 0,
                        fotos:[
                            {
                                imgPath: "static/imgs/exp/albuns/CABEDELO/105.jpg",
                                legenda: "A praia do Dique é frequentada por banhistas que buscam tranquilidade em suas águas quentes e relaxantes. Uma construção de pedras, denominada de quebra-mar, se estende nas águas, justamente na área onde há o encontro do rio Paraíba com o oceano Atlântico"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/CABEDELO/106.jpg",
                                legenda: "A cidade de Cabedelo tem personalidade própria e muitos encantos, a começar pela localização, entre o Oceano Atlântico e o Rio Paraíba, um verdadeiro paraíso para os amantes dos esportes náuticos"
                            },
                        ]
                    },
                    {
                        id: 4,
                        legenda: "PISCINA NATURAL DOS SEIXAS",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/110.jpg",
                                legenda: "Simplesmente maravilhosas as Piscinas Naturais do Seixas. Elas aparecem na maré baixa com uma infinidade de peixes coloridos que vivem no local."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/111.jpg",
                                legenda: "Apenas 500 metros separam esse paraíso da Ponta do Seixas, o ponto mais oriental das Américas, onde o sol nasce primeiro, antes das 5h da manhã e se põe por volta das 17:30h."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/112.jpg",
                                legenda: "As Piscinas do Seixas com João Pessoa ao fundo. Um cenário paradisíaco, repleto de biodiversidade e de momentos únicos para a sua vida."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/92.jpg",
                                legenda: "Um dos mais belos ecossistemas recifais do Brasil, com suas águas mornas e cristalinas, com piscinas que variam de 1 a 3 metros de profundidade."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/93.jpg",
                                legenda: "Piscinas naturais do Seixas, mais um paraíso da nossa Paraíba. Localizadas a 800 metros da Praia da Penha. Um excelente mergulho para você! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PISCINA NATURAL DOS SEIXAS/94.jpg",
                                legenda: "Cores perfeitas, o Farol do Cabo Branco indicando a direção, a liberdade de ir e vir em mares quentes e calmos. Eita Paraíba linda!!"
                            },
                        ]
                    },
                    {
                        id: 5,
                        legenda: "BAÍA DA TRAIÇÃO",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/16.jpg",
                                legenda: "Esse índio é o Raqué, ele é da aldeia Alto do Tambá na Baía da Traíção, foi cacique geral por mais de 35 anos, é um representante da etnia Potiguara, e com certeza um ícone da BT. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/17.jpg",
                                legenda: "Baía da Traição, um lugar para se amar. Inevitável. Nós amamos BT! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/18.jpg",
                                legenda: " Diretamente de São Paulo a nossa querida turista Aldrei Sarcinelli, aproveitando um pouco da cultura Potiguar, e vivendo uma inesquecível experiência nativa em Baía da Traição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/19.jpg",
                                legenda: " O artesanato indígena movimenta o cenário turístico de Baía da Traição. Venha e conheça mais dessa linda cultura potiguar. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/20.jpg",
                                legenda: " Quanta riqueza natural em uma só imagem. Ainda no extremo norte da Paraíba apresentamos o município de Baía da Traição. Conhecida por suas aldeias indígenas, belíssimas praias, além do seu artesanato local, e danças atreladas a sua cultura."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/21.jpg",
                                legenda: " Com a Nissan Frontier a nossa expedição estará sempre na melhor direção. Iremos cada vez mais longe, pois o espírito da aventura está conosco! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/22.jpg",
                                legenda: "Espírito de aventura Nissan Frontier."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/23.jpg",
                                legenda: "Sem limites para a nossa expedição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/35.jpg",
                                legenda: " Para você que gosta de arte, não pode deixar de fazer uma visita ao Ateliê Arte Potiguara, localizado na aldeia Tracoeira na Baia da Traição. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/36.jpg",
                                legenda: "Ateliê Arte Potiguara, localizado na aldeia Tracoeira na Baia da Traição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/37.jpg",
                                legenda: " Sever é o artista plástico e o artesão que está à frente do Ateliê Arte Potiguara, localizado na aldeia Tracoeira na Baia da Traição. Muitas opções para os que não resistem a uma arte nativa. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/41.jpg",
                                legenda: " Baía da Traição é um dos municípios mais tradicionais e antigos da Paraíba. Belíssimas praias, uma boa estrutura de restaurantes e pousadas. Possui lagoas lindas como a Lagoa do Mato, a Lagoa Encantada, e a Aldeia Perdida."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/44.jpg",
                                legenda: "Acendendo o forno para fazer o famoso “Beijú”."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/45.jpg",
                                legenda: " A Baía da Traição possui uma gastronomia diversificada, com deliciosas iguarias, de origem indígena. O “Beijú” é uma delas."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/46.jpg",
                                legenda: " O Beijú mais tradicional e original do Brasil é o “Beijú da Angelina”, que fica na Aldeia Alto do Tambá, no município da Baía da Traição. Talvez o único Beijú no Brasil que é feito do jeito original, sem industrialização alguma, totalmente artesanal. Muito trabalhoso, mas Angelina não abre mão de manter a tradição. Além do sabor incomparável, é claro."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/47.jpg",
                                legenda: "O Beijú da Angelina. Inesquecível!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/48.jpg",
                                legenda: "O Beijú cheio de amor e detalhes. Parabéns Angelina."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/49.jpg",
                                legenda: " O Beijú parece uma tapioca, mas existe uma diferença bem simples: O igrediente. Enquanto a tapioca é feita a partir da goma da mandioca, o beijú é preparado a partir da massa da mandioca. Cada um desses ingredientes leva um processo de preparação diferente e isso resulta diretamente na consistência do prato. A tapioca possui uma liga maior, enquanto o beijo é mais seco e durinho. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/51.jpg",
                                legenda: " Uma saladinha muito saborosa, com frutas típicas da terra do restaurante Terraço Potiguara em Baía da Traição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/52.jpg",
                                legenda: " Há quem resista a um tradicional ensopado de marisco? Claro que não. Isso é muito mais você encontra no restaurante Terraço Potiguara em Baía da Traição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/54.jpg",
                                legenda: " Os antigos canhões, hoje encontrados na praia do Forte, em Baía da Traição, são peças da artilharia do Forte, construído pelos portugueses sobre o local histórico Alto do Tambá. Aqui tem muita praia, mas também muita história, vale demais a visita e o registro."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/68.jpg",
                                legenda: " Experiência nativa em Baía da Traição."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/69.jpg",
                                legenda: " Experiência nativa em Baía da Traição. Algo sem preço! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/70.jpg",
                                legenda: "Essa é a nascente do rio Dendê na aldeia Cumarú na Baia da Traição. Mais um capricho de Deus em nossa terra. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/71.jpg",
                                legenda: "Cacique Raqué."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/BAIA DA TRAICAO/72.jpg",
                                legenda: "Todo dia é dia de índio. Cacique Raqué."
                            },
                        ]
                    },
                    {
                        id: 6,
                        legenda: "PICÃOZINHO",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/PICAOZINHO/107.jpg",
                                legenda: " Algumas das mais belas paisagens naturais da Paraíba só podem ser vistas dentro da água. A menos de dois quilômetros da badalada Praia de Tambaú ficam as piscinas naturais de Picãozinho, um dos principais cartões-postais da capital paraibana, e passeio obrigatório para qualquer pessoa que visita a cidade.  "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PICAOZINHO/108.jpg",
                                legenda: " Formadas entre arrecifes de corais e pedras, as piscinas naturais de Picãozinho mantêm águas transparentes, com temperatura agradável em torno dos 26 graus. A #dicaadvice é @vitorembarcacoesturismo, embarcação com melhor estrutura e atendimento. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PICAOZINHO/109.jpg",
                                legenda: " Em Picãozinho, os turistas são agraciados com a presença de cardumes de peixes coloridos. É possível vê-los a olho nu, mas o ideal é alugar snorkel, para ter uma experiência ainda mais exuberante. Para melhor preservação do local, não é permitido subir nos corais e nem alimentar os peixes.  "
                            },
                        ]
                    },
                    {
                        id: 7,
                        legenda: "CARIBESSA",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/CARIBESSA/89.jpg",
                                legenda: " Uma imagem ao maior estilo Caribessa. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/CARIBESSA/90.jpg",
                                legenda: " Tudo se complementa: A cidade, o mar, e o céu. João Pessoa, a praia do Bessa, e as nuvens dando a liga. Não fica para trás de nenhum lugar do mundo. Bela Paraíba!  "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/CARIBESSA/91.jpg",
                                legenda: " Vai dizer que você não queria estar aí... "
                            },
                        ]
                    },
                    {
                        id: 8,
                        legenda: "PRAIA DO JACARÉ",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/59.jpg",
                                legenda: " A Nissan Frontier acredita em novas ideias. Acredita no turismo da Paraíba!! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/60.jpg",
                                legenda: " Uma harmonia em cores no estaleiro da Praia do Jacaré. Algo sublime, sutil, perfeito."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/61.jpg",
                                legenda: " A Nissan Frontier está sempre presente nos melhores lugares. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/62.jpg",
                                legenda: " A nossa Expedição nos levou para contemplar o pôr-do-sol mais charmoso do Brasil."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/73.jpg",
                                legenda: " O pôr do sol na Praia do Jacaré é deslumbrante e se tornou uma espécie de parada obrigatória para qualquer turista que aparece pela Paraíba"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/74.jpg",
                                legenda: " Um momento único, imperdível ao som do Bolero de Ravel tudo bem sincronizado com a despedida do astro-rei."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/75.jpg",
                                legenda: "Sobre as águas do Rio Paraíba o musicista Jurandir do Sax em uma canoa e com seu tradicional saxofone toca o Bolero de Ravel."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/76.jpg",
                                legenda: " Uma imagem que nos coloca em modo “agradável”. Vem passear na Praia do Jacaré, algo para toda a família. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/77.jpg",
                                legenda: " O artesanato local sempre fez parte do roteiro turístico da Praia do Jacaré. A cultura paraibana estampada em várias peças. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/78.jpg",
                                legenda: " Tem Paraíba para todos os gostos."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/79.jpg",
                                legenda: " Que tal o estaleiro da Praia do Jacaré em um lindo Crepúsculo? Imperdível. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/80.jpg",
                                legenda: " A Nissan Frontier está sempre presente nos melhores lugares. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/81.jpg",
                                legenda: " Algo a se admirar. A nossa Paraíba."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/82.jpg",
                                legenda: "”A Ribeira.”"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/83.jpg",
                                legenda: " Um lugar para várias atividades. A Praia do Jacaré é palco para quem quer navegar, esquiar, contemplar, remar... só conhecendo. E você tá esperando o quê?"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/84.jpg",
                                legenda: " A Praia do Jacaré, com a praia de Intermares ao fundo... é muita beleza para ver só uma vez. Fique a vontade para desfrutar dessa vista o quanto quiser."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/85.jpg",
                                legenda: "A majestade do Rio Paraíba. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/86.jpg",
                                legenda: " Praia do Jacaré. O nome surgiu porque nos anos 60 havia uma base dos Correios, como se fosse um hidroporto, no qual pousava aviões do tipo Catalina. Quando a aeronave descia as águas, formava-se uma onda com a aparência de uma boca aberta. Daí, os ribeirinhos apelidaram o local de Jacaré. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/87.jpg",
                                legenda: " Os primeiros moradores da Praia do Jacaré eram pescadores e artesãos. Continuam por lá, mantendo as suas tradições, e recebendo com muita alegria todos os visitantes."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/PRAIA DO JACARE/88.jpg",
                                legenda: " A simplicidade do povo paraibano se mistura com a beleza natural de sua terra. Com raízes históricas densas, o nossos Estado se mostra com orgulho. Venha nos visitar, e desfrute dos nossos tesouros nativos! "
                            },
                        ]
                    },
                    {
                        id: 9,
                        legenda: "LUCENA",
                        indFoto: 0,
                        fotos: [
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/100.jpg",
                                legenda: " Contam os historiadores que a fundação da construção advém do tempo da colonização, sendo uma das primeiras Igrejas do Brasil."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/101.jpg",
                                legenda: " Construída pelos frades carmelitas, entre o final do século XVI e XVII, a Igreja de Nossa Senhora da Guia está localizada no município de Lucena, litoral norte e teve um papel importante na catequização dos índios daquela região."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/102.jpg",
                                legenda: "Do alto da colina pode se ver, no outro lado do Rio Paraíba, a cidade de Cabedelo, onde localiza-se o Forte de Santa Catarina. Devido a essa visão o local foi eventualmente utilizado como posto de observação contra ataques inimigos. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/103.jpg",
                                legenda: " Construida em pedra caucárea realizada em estilo barroco é uma das igrejas mais antigas do Pais, localizada numa área de preservação onde podemos ver resquícios de mata Atlântica. "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/104.jpg",
                                legenda: " Nossa missão é mostrar o que a Paraíba tem de melhor. Os caminhos mais severos exigem a resistência que está no DNA da Nissan Frontier, juntos estamos preparados para enfrentar qualquer desafio"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/113.jpg",
                                legenda: " A Nissan acredita no turismo da Paraíba."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/114.jpg",
                                legenda: " Uma viagem de experiências, lugares deslumbrantes e a magia do descobrimento que ganha vida em nossos corações."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/115.jpg",
                                legenda: " Uma mistura de emoções, paisagens inesquecíveis e muita aventura. Eita Paraíba bonita! "
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/95.jpg",
                                legenda: "Lucena meu amor. Que vista!"
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/96.jpg",
                                legenda: "Robusta. Essencial. Frontier."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/97.jpg",
                                legenda: "Valor. Presença. Nissan. Lucena."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/98.jpg",
                                legenda: " Em meio à Mata Atlântica, as ruínas da Igreja de Bonsucesso confundem-se com a natureza a sua volta."
                            },
                            {
                                imgPath: "static/imgs/exp/albuns/LUCENA/99.jpg",
                                legenda: " Construída no final do século XVIII, pelos padres da Ordem Carmelita, tem parte de sua estrutura feita em alvenaria de pedra calcária e arenito, apoiada em uma gigante gameleira centenária."
                            },
                        ]
                    },
                ],
                albInd: 0,
            }
        },
        methods: {
            sleep (time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            },
            sendNewsletter() {
                console.log('sendNewsletter ' + this.new_email);
                if (!this.checkEmail()) {
                    alert("Endereço de e-mail inválido.");
                }
                else {
                    var url = this.baseUrlApi + 'addnewsletter';

                    var data = {
                        'email': this.new_email,
                        idlocal: 1
                    };

                    console.log("Enviando post com o newsletter");
                    console.log(url);
                    axios.post(url, qs.stringify(data))
                        .then(function (response) {
                            //vm.loading.form = false;
                            console.log("SUCESS::" + response);
                        })
                        .catch(function (error) {
                            //vm.loading.form = false;
                            console.log("ERROR::" + error);
                        });

                    this.sleep(1000).then(() => {
                        alert("Que bom que você está conosco, aproveite a viagem!");
                    });

                    //this.$nextTick(function () {
                    //    alert("Que bom que você está conosco, aproveite a viagem!");
                    //});

                }
            },
            checkEmail() {
                var email = this.new_email;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            showdiv(i) {
                var target;
                switch (i) {
                    case 0:
                        target = document.getElementById('part0');
                        break;
                    case 1:
                        target = document.getElementById('part1');
                        break;
                    case 2:
                        target = document.getElementById('part2');
                        break;
                    case 3:
                        target = document.getElementById('part3');
                        break;
                    case 4:
                        target = document.getElementById('part4');
                        break;
                    case 5:
                        target = document.getElementById('part5');
                        break;
                    default:
                        target = document.getElementById('part1');
                }
                $('html,body').animate({
                        scrollTop: target.offsetTop},
                    'slow');
            },
            smoothScroll(i) {
                var target = document.getElementById('part1');
                var scrollContainer = target;
                do { //find scroll container
                    scrollContainer = scrollContainer.parentNode;
                    if (!scrollContainer) return;
                    scrollContainer.scrollTop += 1;
                } while (scrollContainer.scrollTop == 0);

                var targetY = 0;
                do { //find the top of target relatively to the container
                    if (target == scrollContainer) break;
                    targetY += target.offsetTop;
                } while (target = target.offsetParent);

                scroll = function(c, a, b, i) {
                    i++; if (i > 30) return;
                    c.scrollTop = a + (b - a) / 30 * i;
                    setTimeout(function(){ scroll(c, a, b, i); }, 20);
                }
                // start scrolling
                scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
            },
            share() {
                this.showShare = !this.showShare;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            showGalery(id, show) {
                this.albInd = id;
                if (show)
                    $('.overgalery').fadeIn();
                else
                    $('.overgalery').fadeOut();
            },
            nextPhoto(inc) {
                if (inc >= 0)
                    this.albuns[this.albInd].indFoto = (this.albuns[this.albInd].indFoto + inc) % this.albuns[this.albInd].fotos.length;
                else {
                    if (this.albuns[this.albInd].indFoto==0)
                        this.albuns[this.albInd].indFoto = this.albuns[this.albInd].fotos.length-1;
                    else
                        this.albuns[this.albInd].indFoto = (this.albuns[this.albInd].indFoto + inc);
                }
            },
            getPhotoIndex(index) {
                return (this.albuns[this.albInd].indFoto + index) % this.albuns[this.albInd].fotos.length;
            },


            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },

        created() {
            console.log('created do Estabelecimento!!');

            // if (this.$route.params.stabs) {
            //     console.log('Usando estabs e cats passados por parametro!!');
            //     this.estabs_full = this.$route.params.stabs;
            //     this.cats_full = this.$route.params.categs;
            //     this.atualizaParametros();
            // }
            // else {
            //     console.log('Baixando estabs!!');
            //     this.getEstabsCats();
            // }

            console.log('Terminei o created do Estabelecimento!!');
        },

        mounted() {
            console.log('mounted do Estabelecimento!!');

            $(document).ready(function () {
                $('#dismiss, .overlay').on('click', function () {
                    $('#div_pat_s').fadeOut(0);
                    $('#sidebar').removeClass('active');
                    $('.overlay').fadeOut();
                    $('#icmenu').removeClass('open');
                });

                $('#sidebarCollapse').on('click', function () {
                    $('#sidebar').addClass('active');
                    $('.overlay').fadeIn();
                    $('.collapse.in').toggleClass('in');
                    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
                    $('#div_pat_s').fadeIn();
                });
            });

            $('#div_pat_s').fadeOut(0);

            this.barra_pat = this.shuffle(this.barra_pat);

            console.log('Terminei o mounted do Estabelecimento!!');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .head0 {
        position: fixed;
        top: 0;
        z-index: 10;
    }
    .head0_2 {
        /*background-color: blue;*/
        background-image: url("/static/imgs/exp/top_bar.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
        width: 100vw;
        height: 210px;
        height: 25vh;
        position:relative;
        font-size: 0;
    }
    .im_social_vert {
        /*width: 35px;*/
        width: 2.5vw;
        padding: 3px;
        margin-top: 7px;
        margin-bottom: 7px;
        padding-top: 4px;
        padding-bottom: 4px;
    }
    .barra_flutua {
        z-index: 2;
        position: fixed;
        top: 50%;
        left: 97%;
        transform: translate(-50%, -50%);
        width: 50px;
        text-align: center;
        /*background-color: #2c3e50;*/
        background-image: url('/static/imgs/exp/bg_sociais.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .im_logol {
        height: 23vh;
        vertical-align: middle;
    }
    .im_expadvice {
        /*height: 210px;*/
        width: 52vw;
    }
    .im_parceiro {
        width: 200px;
        width: 17vw;
    }
    .imF2 {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .im_pneu {
        width: 90px;
        width: 6.3vw;
        margin-right: 10px;
        margin-left: 10px;
        margin-top: -45px;
        margin-top: -3.3vw;
    }
    .divF2 {
        position: unset;
        display: inline-block;
        /*width: 310px;*/
        width: 29vw;
        margin-right: 1vw;
        text-align: left;
        alignment: bottom;
        /*height: 217px;*/
        height: 15vw;
        margin-bottom: 1vw;
    }
    .divF2:hover {
        transform: scale(1.03);
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }
    .back01 {
        top: 0;
        position: fixed;
        z-index: 0;
        /*background-color: #002a5e;*/
        background-color: #002b51;
        background-image: url('/static/imgs/exp/bg_exp_0home.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
        width: 100%;
        height: 100vh;
        /*background-color: #E4E4E4;*/
    }
    .bodyp1 {
        position: relative;
        top: 55%;
        transform: translateY(-50%);
    }
    .sp_interno, .sp_interno2 {
        top:0;
        color: white;
        font-size: 17pt;
        font-size: 1.5vw;
        font-family: Segoeui;
        text-align: justify;
        display: block;
    }
    .sp_interno2 {
        text-align: right;
    }
    .bodysubp2 {
        /*background-color: red;*/
        top: 0;
        position: relative;
        display: inline-block;
        text-align: center;
        /*width: 30%;*/
    }

    .div_arrow_l, .div_arrow_r {
        position: absolute;
        top:0;
        height: 100%;
        min-width: 40px;
        vertical-align: center;
    }
    .div_arrow_r {
        right: 10px;
    }
    .div_arrow_l {
        left: 10px;
    }
    .im_arrow {
        position: absolute;
        vertical-align: middle;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;
    }
    .im_arrow:hover {
        -webkit-filter: brightness(70%);
        filter: brightness(70%);
    }
    .div_galery {
        background-color: white;
        display: inline-block;
        position: relative;
        padding-top: 1vw;
        padding-right: 1vw;
        padding-left: 1vw;
        width: 100%;
    }
    .imgGalery {
        width: 100%;
        object-fit: contain;
    }
    .di_part1, .di_part2, .di_part3, .di_part4, .di_part5 {
        padding-top: 25vh;
        position: relative;
        text-align: center;
        width: 100%;
        height: 100vh;
        background-image: url('/static/imgs/exp/bg_exp_1quem.jpg');
        background-size: cover;
        background-position: center;
        z-index: 1;
    }
    .di_part1 {
        margin-top: 100vh;
    }
    .di_part2 {
        background-image: url('/static/imgs/exp/bg_exp_2equipe.jpg');
    }
    .di_part3 {
        background-image: url('/static/imgs/exp/bg_exp_3parceiros.jpg');
    }
    .di_part4 {
        font-size: 0;
        padding-top: 24vh;
        background-image: url('/static/imgs/exp/bg_exp_4galeria.jpg');
    }
    .di_part5 {
        background-image: url('/static/imgs/exp/bg_exp_5producao.jpg');
    }
    .sp_title {
        font-size: 55pt;
        font-size: 5vw;
        font-family: BebasNeueBold;
        /*font-color: #0071BB;*/
        font-color: white;
        color: white;
        /*background-color: red;*/
        text-decoration: underline;
    }
    .sp_tit_img {
        position:absolute;
        /*display: initial;*/
        height: 60px;
        color: white;
        bottom: 0;
        font-size: 35pt;
        font-size: 3.25vw;
        font-family: BebasNeueBold;
        margin-bottom: 30px;
        margin-bottom: 2.1vw;
        margin-left: 25px;
        text-decoration: underline;
        /*background-color: red;*/
    }
    .di_news {
        width: 100%;
        text-align: center;
        alignment: center;
        position: absolute;
        bottom: 6%;
    }
    .di_patro, .di_patro_im {
        width: 25%;
        display: inline-block;
        vertical-align: top;
    }
    .di_patro_im {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
    .ipt_news {
        background-image: url('/static/imgs/bg_search01m2.png');
        background-color: transparent;
        background-size: contain;
        background-repeat: no-repeat;
        background-size: 100% 26px;
        border: none;
        outline:none;
        position: relative;
        padding-left: 10px;
        margin-left: 20px;
        margin-right: 20px;
        width: 300px;
        height: 28px;
    }
    .bt_criar {
        display: inline-block;
        margin-top: 5px;
        position: relative;
        text-align: center;
        width: 100px;
    }
    .span_criar {
        position: absolute;
        font-size: 16pt;
        font-family: BebasNeueBold;
        color: #002b51;
        top: 58%;
        left: 50%;
        transform: translate(-50%, -50%);
    }


    .im_categoria2 {
        background-size: contain;
        object-fit: cover;
        width: 90%;
        height: 90%;
    }
    .di_categoria {
        /*background-color: blue;*/
        position: relative;
        display: inline-block;
        width: 30%;
        width: 21vw;
        height: 35%;
        height: 13vw;
        min-width: 10px;
        min-height: 10px;
        text-align: center;
        margin-bottom: 2vh;
    }
    .scrollhorizontal {
        height: 65vh;
        width: 84vw;
        margin-top: -2vh;
        display: inline-block;
        text-align: left;
        overflow-y: auto;
        /*background-color: blue;*/
    }
    .tx_categoria, .tx_categoria2, .tx_categoria3 {
        /*background-color: yellow;*/
        display: inline-grid;
        white-space: pre-line;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        color: white;
        font-family: Segoeui;
        margin-left: 1vh;
        /*line-height: 0.9;*/
        font-size: 1vw;
    }
    .tx_categoria2 {
        margin-left: 0;
        text-align: justify;
        color: black;
        /*margin-left: 2vw;*/
    }
    .tx_categoria3 {
        font-size: 2vw;
    }
    .im_close {
        /*background-color: red;*/
        width: 4vh;
        height: 4vh;
        margin-top: 1vh;
        margin-right: 2vh;
    }
    .overgalery {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(10, 10, 10, 0.85);
        z-index: 20;
        display: none;
        vertical-align: middle;
        text-align: center;
        top: 0;
    }
    .galery_container {
        position: relative;
        display: inline-block;
        text-align: left;
        height: 89vh;
        width: 60vw;
        overflow-y: scroll;
        margin-top: 0vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Expedicao.vue